
















































import { defineComponent, computed } from '@vue/composition-api';

import { CardUploadStatusEnum } from '@/widgets/ocr-identity/enums';
import { OCRModeEnum, UploadTypeEnum } from '@/shared/tools/ocr/enum';

export default defineComponent({
  name: 'IdentityCard',
  props: {
    image: {
      type: String,
      default: '',
    },
    /** 上传方式  */
    uploadType: {
      default: UploadTypeEnum.SDKCamera,
    },
    // 证件正反面
    cardType: {
      default: OCRModeEnum.FRONT,
    },
    // 识别状态
    uploadStatus: {
      default: CardUploadStatusEnum.PENDING,
    },
  },
  emits: ['delete', 'upload'],
  setup(props, context) {
    /** 是否是正面（人像面） */
    const isFront = computed(() => props.cardType === OCRModeEnum.FRONT);
    /** 身份证上传状态 */
    const uploadStatus = computed(() => props.uploadStatus);
    /** 是否是成功 */
    const isSuccess = computed(() => uploadStatus.value === CardUploadStatusEnum.SUCCESS);
    /** 是否待上传 */
    const isPending = computed(() => (uploadStatus.value === CardUploadStatusEnum.PENDING
    || uploadStatus.value === CardUploadStatusEnum.DELETE));
    /** 是否是拍摄 */
    const isCamera = computed((
    ) => props.uploadType === UploadTypeEnum.SDKCamera);

    const onDelete = () => {
      context.emit('delete', props.cardType);
    };

    /** 点击识别失败、相机、+ - 重新上传 */
    const handleClick = () => {
      if (uploadStatus.value !== CardUploadStatusEnum.SUCCESS) {
        context.emit('upload');
      }
    };

    return {
      isFront,
      uploadStatus,
      isSuccess,
      isPending,
      isCamera,
      OCRModeEnum,
      CardUploadStatusEnum,
      handleClick,
      onDelete,
    };
  },
});

